import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { REPORTES_API } from "../../api/reportesApi";


import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

/* =========================
   HELPERS
========================= */
const mesesLabels = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];

const pct = (a, b) => {
  if (b === 0 || b == null) return null;
  return ((a - b) / b) * 100;
};

const fmtNum = (n) =>
  n == null ? "—" : new Intl.NumberFormat("es-MX").format(Number(n));

const fmtPct = (n) =>
  n == null ? "—" : `${n > 0 ? "+" : ""}${n.toFixed(1)}%`;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

console.log("REPORTES_API =", REPORTES_API, typeof REPORTES_API);


/* =========================
   COMPONENT
========================= */
export default function ReportesComparativo() {
  const [anioUpload, setAnioUpload] = useState(new Date().getFullYear());
  const [file, setFile] = useState(null);
  const [uploadState, setUploadState] = useState("idle");
  const [uploadMsg, setUploadMsg] = useState("");

  const [anios, setAnios] = useState([
    new Date().getFullYear() - 1,
    new Date().getFullYear(),
  ]);

  const [dataMulti, setDataMulti] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const [dataErr, setDataErr] = useState("");

  const selectedAnios = useMemo(
    () => [...new Set(anios)].sort((a, b) => a - b),
    [anios]
  );

  /* =========================
     FETCH MULTI
  ========================= */
  const fetchMulti = async (years = selectedAnios) => {
    setLoadingData(true);
    setDataErr("");
    try {
      const res = await axios.get(
        `${REPORTES_API}/reportes/comparativo/multi`,
        { params: { anios: years.join(",") } }
      );
      setDataMulti(res.data?.data || null);
    } catch (e) {
      setDataErr("Error cargando comparativo");
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchMulti();
    // eslint-disable-next-line
  }, []);

  /* =========================
     UPLOAD FLOW
  ========================= */
  const handleUpload = async () => {
    if (!file) {
      setUploadState("error");
      setUploadMsg("Selecciona un archivo .xlsx");
      return;
    }

    try {
      setUploadState("gettingUrl");
      const { data } = await axios.post(
        `${REPORTES_API}/reportes/comparativo/upload-url`,
        { anio: Number(anioUpload) }
      );

      const uploadUrl = data.uploadUrl;
      if (!uploadUrl) throw new Error("No llegó uploadUrl");

      setUploadState("uploading");
      await axios.put(uploadUrl, file, {
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      setUploadState("processing");

      let ok = false;
      for (let i = 0; i < 20; i++) {
        try {
          await axios.get(`${REPORTES_API}/reportes/comparativo`, {
            params: { anio: Number(anioUpload) },
          });
          ok = true;
          break;
        } catch {
          await sleep(3000);
        }
      }

      if (!ok) throw new Error("Timeout de procesamiento");

      setUploadState("done");
      setUploadMsg("✅ Excel procesado correctamente");
      setAnios((a) => [...new Set([...a, Number(anioUpload)])]);
      fetchMulti();

    } catch (e) {
      setUploadState("error");
      setUploadMsg(e.message);
    }
  };

  /* =========================
     UI
  ========================= */
  return (
    <div className="min-h-screen p-6 bg-[#0b1220] text-white">
      <h1 className="text-3xl font-semibold">Comparativo Anual</h1>

      <div className="mt-6 flex gap-4">
        <input
          type="number"
          value={anioUpload}
          onChange={(e) => setAnioUpload(e.target.value)}
          className="px-3 py-2 rounded bg-black/30 border border-white/20"
        />
        <input
          type="file"
          accept=".xlsx"
          onChange={(e) => setFile(e.target.files?.[0])}
        />
        <button
          onClick={handleUpload}
          className="px-4 py-2 bg-sky-500/30 rounded"
        >
          Subir Excel
        </button>
      </div>

      {uploadMsg && <div className="mt-3">{uploadMsg}</div>}

      {loadingData && <div className="mt-4">Cargando KPIs…</div>}
      {dataErr && <div className="mt-4 text-red-400">{dataErr}</div>}

      <pre className="mt-6 text-xs bg-black/40 p-4 rounded">
        {JSON.stringify(dataMulti, null, 2)}
      </pre>
    </div>
  );
}
